import { render } from "./ArticleIcon.vue?vue&type=template&id=382f0cd6"
const script = {}

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__